import React, { useEffect, useState } from 'react';
import { Row, Col, FormGroup, Label, Card, CardBody } from 'reactstrap';
import DatePicker from 'react-datepicker';
import ReactGA from 'react-ga4';
import moment from 'moment';
import { toast } from 'react-toastify';
import { dataFinalAnteriorInicial } from '~/helpers/date';
import { ButtonStyled } from './styles';

export function FiltroGeral(props) {
	const { setLoading, setParams, setPagina, showPaginaGrupo = true, setPaginaGrupo = (event) => console.log(event), dataRange, setDataRange, nomeTela = '', children } = props;

	const [isMobile, setIsMobile] = useState(false);

	const [button, setButton] = useState({
		hoje: true,
		dias7: false,
	});

	const [, setFilter] = useState('');

	function handlerFiltrarHoje() {
		setFilter('todos');
		setLoading(true);

		setButton({
			hoje: true,
			dias7: false,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);
		if(showPaginaGrupo){
			setPaginaGrupo(1);
		}

		handleFiltroHojeGA4();
	}

	function handlerFiltrar7Dias() {
		setFilter('sete_dias');
		setLoading(true);

		setButton({
			hoje: false,
			dias7: true,
		});

		setParams({
			dateInit: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setPagina(1);
		if(showPaginaGrupo){
			setPaginaGrupo(1);
		}
		handleFiltro7DiasGA4();
	}

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if(dataRange.dateInit || dataRange.dateInit){
			setParams({
				dateInit: dataRange.dateInit ? moment(dataRange.dateInit).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
				dateEnd: dataRange.dateEnd ? moment(dataRange.dateEnd).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
			});

			setButton({
				hoje: false,
				dias7: false,
			});
		}

		if (dataRange.dateEnd !== '') {
			if (dataFinalAnteriorInicial(dataRange.dateInit, dataRange.dateEnd)) {
				toast.warning('Data final não pode ser anterior a data inicial');
				setDataRange({
					dateInit: '',
					dateEnd: '',
				});

				setButton({
					hoje: false,
					dias7: true,
				});
			}
		}
	}, [dataRange]);

	function handleFiltroHojeGA4() {
		ReactGA.event({
			category: `filtro_hoje_${nomeTela.toLowerCase()}_click`,
			action: `Filtro Hoje ${nomeTela}`,
			label: `Filtrando Hoje ${nomeTela}`,
		});
	}

	function handleFiltro7DiasGA4() {
		ReactGA.event({
			category: `filtro_7dias_${nomeTela.toLowerCase()}_click`,
			action: `Filtro 7 dias ${nomeTela}`,
			label: `Filtrando 7 dias ${nomeTela}`,
		});
	}

	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data inicial"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block"
						selected={dataRange.dateInit}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateInit: value,
							})
						}
					/>
				</FormGroup>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data final"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block w-100"
						selected={dataRange.dateEnd}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateEnd: value,
							})
						}
					/>
				</FormGroup>
			</Col>
		</>
	)

	return (
		<Card
			style={{
				boxShadow: 'unset',
				borderRadius: '0px 18px 18px 18px',
				margin:'0px'
			}}>
			<CardBody>
				<Row>
					<Col md="4" sm="12">
						<FormGroup>
							<Label className="d-block">
								Filtrar por período
							</Label>
							<Row>
								<Col>
									<ButtonStyled
										className="w-100 my-0"
										disabled={button.hoje}
										onClick={() => handlerFiltrarHoje()}>
										Hoje
									</ButtonStyled>
								</Col>
								<Col>
									<ButtonStyled
										className="w-100 my-0"
										disabled={button.dias7}
										onClick={() => handlerFiltrar7Dias()}>
										7 dias
									</ButtonStyled>
								</Col>
							</Row>
						</FormGroup>
					</Col>
					<Col sm="12" md='8'>
						<FormGroup>
							<Label className="d-block">Filtrar por data</Label>
							{!isMobile ?
								<Row>
									{ColData}
								</Row>
								: <>{ColData}</>
							}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col>
						{children}
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
}
